/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Team_RequiredInputs */

const en_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Manager requires a team account. Please join or create a team to use this feature.`)
};

const fr_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le gestionnaire KNP nécessite un compte d’équipe. Veuillez rejoindre ou créer une équipe pour utiliser cette fonctionnalité.`)
};

const de_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für KNP Manager ist ein Teamkonto erforderlich. Bitte treten Sie einem Team bei oder erstellen Sie ein neues, um diese Funktion nutzen zu können.`)
};

const it_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Manager richiede un account team. Unisciti a un team o creane uno per utilizzare questa funzionalità.`)
};

const ru_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для использования KNP Manager требуется командный аккаунт. Пожалуйста, присоединитесь к команде или создайте свою, чтобы использовать эту функцию.`)
};

const es_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Manager requiere una cuenta de equipo. Únase o cree un equipo para usar esta función.`)
};

const zh_cn2_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Manager 需要团队帐户。请加入或创建团队以使用此功能。`)
};

const ja_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPマネージャーにはチームアカウントが必要です。この機能を使用するには、チームに参加するか、チームを作成してください。`)
};

const hi_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP मैनेजर के लिए टीम अकाउंट आवश्यक है। इस सुविधा का उपयोग करने के लिए कृपया किसी टीम में शामिल हों या नई टीम बनाएं।`)
};

const pt_pt2_knp_manager_team_required = /** @type {(inputs: Knp_Manager_Team_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O KNP Manager requer uma conta de equipe. Por favor, junte-se a uma equipe ou crie uma para usar este recurso.`)
};

/**
* | output |
* | --- |
* | "KNP Manager requires a team account. Please join or create a team to use this feature." |
*
* @param {Knp_Manager_Team_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_team_required = /** @type {((inputs?: Knp_Manager_Team_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Team_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_team_required(inputs)
	if (locale === "de") return de_knp_manager_team_required(inputs)
	if (locale === "it") return it_knp_manager_team_required(inputs)
	if (locale === "ru") return ru_knp_manager_team_required(inputs)
	if (locale === "es") return es_knp_manager_team_required(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_team_required(inputs)
	if (locale === "ja") return ja_knp_manager_team_required(inputs)
	if (locale === "hi") return hi_knp_manager_team_required(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_team_required(inputs)
	return en_knp_manager_team_required(inputs)
});